import type { Template } from "@/types";

export const LA_06_H1_V5: Template[] = [
{
    id: "la-05-h1v5-01",
    name: "LA 01 - H1V5",
    albumType: "LA",
    thumbnail: "/thumbnails/LA/AR_2.50/la-06-h1_v5_01.png",
    size: [1274, 476],
    style: {},
    slots: [
            { id: "1", x: 101, y: 95, width: 215, height: 287, rotation: 0, imageRotation: 0 },
            { id: "2", x: 323, y: 95, width: 214, height: 287, rotation: 0, imageRotation: 0 },
            { id: "3", x: 760, y: 34, width: 389, height: 227, rotation: 0, imageRotation: 0 },
            { id: "4", x: 760, y: 268, width: 125, height: 173, rotation: 0, imageRotation: 0 },
            { id: "5", x: 892, y: 268, width: 124, height: 173, rotation: 0, imageRotation: 0 },
            { id: "6", x: 1024, y: 268, width: 124, height: 173, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "la-05-h1v5-02",
    name: "LA 02 - H1V5",
    albumType: "LA",
    thumbnail: "/thumbnails/LA/AR_2.50/la-06-h1_v5_02.png",
    size: [1274, 476],
    style: {},
    slots: [
            { id: "1", x: 172, y: 48, width: 292, height: 380, rotation: 0, imageRotation: 0 },
            { id: "2", x: 746, y: 48, width: 135, height: 186, rotation: 0, imageRotation: 0 },
            { id: "3", x: 746, y: 241, width: 135, height: 186, rotation: 0, imageRotation: 0 },
            { id: "4", x: 889, y: 48, width: 276, height: 186, rotation: 0, imageRotation: 0 },
            { id: "5", x: 889, y: 241, width: 135, height: 186, rotation: 0, imageRotation: 0 },
            { id: "6", x: 1031, y: 241, width: 134, height: 186, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "la-05-h1v5-03",
    name: "LA 03 - H1V5",
    albumType: "LA",
    thumbnail: "/thumbnails/LA/AR_2.50/la-06-h1_v5_03.png",
    size: [1274, 476],
    style: {},
    slots: [
            { id: "1", x: 164, y: 251, width: 306, height: 177, rotation: 0, imageRotation: 0 },
            { id: "2", x: 164, y: 48, width: 150, height: 195, rotation: 0, imageRotation: 0 },
            { id: "3", x: 321, y: 48, width: 149, height: 195, rotation: 0, imageRotation: 0 },
            { id: "4", x: 753, y: 48, width: 263, height: 380, rotation: 0, imageRotation: 0 },
            { id: "5", x: 1023, y: 48, width: 131, height: 186, rotation: 0, imageRotation: 0 },
            { id: "6", x: 1023, y: 241, width: 131, height: 186, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "la-05-h1v5-04",
    name: "LA 04 - H1V5",
    albumType: "LA",
    thumbnail: "/thumbnails/LA/AR_2.50/la-06-h1_v5_04.png",
    size: [1274, 476],
    style: {},
    slots: [
            { id: "1", x: 137, y: 48, width: 364, height: 195, rotation: 0, imageRotation: 0 },
            { id: "2", x: 137, y: 249, width: 117, height: 178, rotation: 0, imageRotation: 0 },
            { id: "3", x: 261, y: 249, width: 116, height: 178, rotation: 0, imageRotation: 0 },
            { id: "4", x: 384, y: 249, width: 116, height: 178, rotation: 0, imageRotation: 0 },
            { id: "5", x: 743, y: 91, width: 208, height: 294, rotation: 0, imageRotation: 0 },
            { id: "6", x: 959, y: 91, width: 208, height: 294, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "la-05-h1v5-05",
    name: "LA 05 - H1V5",
    albumType: "LA",
    thumbnail: "/thumbnails/LA/AR_2.50/la-06-h1_v5_05.png",
    size: [1274, 476],
    style: {},
    slots: [
            { id: "1", x: 110, y: 48, width: 417, height: 239, rotation: 0, imageRotation: 0 },
            { id: "2", x: 110, y: 294, width: 99, height: 134, rotation: 0, imageRotation: 0 },
            { id: "3", x: 217, y: 294, width: 99, height: 134, rotation: 0, imageRotation: 0 },
            { id: "4", x: 323, y: 294, width: 99, height: 134, rotation: 0, imageRotation: 0 },
            { id: "5", x: 430, y: 294, width: 98, height: 134, rotation: 0, imageRotation: 0 },
            { id: "6", x: 812, y: 48, width: 286, height: 381, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "la-06-h1v5-06",
    name: "LA 06 - H1V5",
    albumType: "LA",
    thumbnail: "/thumbnails/LA/AR_2.50/la-06-h1_v5_06.png",
    size: [1274, 476],
    style: {},
    slots: [
            { id: "1", x: 77, y: 65, width: 482, height: 351, rotation: 0, imageRotation: 0 },
            { id: "2", x: 713, y: 65, width: 117, height: 171, rotation: 0, imageRotation: 0 },
            { id: "3", x: 713, y: 243, width: 117, height: 170, rotation: 0, imageRotation: 0 },
            { id: "4", x: 838, y: 65, width: 237, height: 350, rotation: 0, imageRotation: 0 },
            { id: "5", x: 1083, y: 65, width: 115, height: 171, rotation: 0, imageRotation: 0 },
            { id: "6", x: 1083, y: 243, width: 115, height: 170, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "la-06-h1v5-07",
    name: "LA 07 - H1V5",
    albumType: "LA",
    thumbnail: "/thumbnails/LA/AR_2.50/la-06-h1_v5_07.png",
    size: [1274, 476],
    style: {},
    slots: [
            { id: "1", x: 121, y: 59, width: 121, height: 176, rotation: 0, imageRotation: 0 },
            { id: "2", x: 121, y: 242, width: 121, height: 176, rotation: 0, imageRotation: 0 },
            { id: "3", x: 249, y: 59, width: 121, height: 176, rotation: 0, imageRotation: 0 },
            { id: "4", x: 249, y: 242, width: 121, height: 176, rotation: 0, imageRotation: 0 },
            { id: "5", x: 377, y: 59, width: 533, height: 359, rotation: 0, imageRotation: 0 },
            { id: "6", x: 918, y: 59, width: 247, height: 359, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "la-06-h1v5-08",
    name: "LA 08 - H1V5",
    albumType: "LA",
    thumbnail: "/thumbnails/LA/AR_2.50/la-06-h1_v5_08.png",
    size: [1274, 476],
    style: {},
    slots: [
            { id: "1", x: 0, y: 74, width: 221, height: 329, rotation: 0, imageRotation: 0 },
            { id: "2", x: 229, y: 74, width: 221, height: 329, rotation: 0, imageRotation: 0 },
            { id: "3", x: 458, y: 74, width: 464, height: 329, rotation: 0, imageRotation: 0 },
            { id: "4", x: 929, y: 74, width: 222, height: 329, rotation: 0, imageRotation: 0 },
            { id: "5", x: 1159, y: 74, width: 115, height: 161, rotation: 0, imageRotation: 0 },
            { id: "6", x: 1159, y: 243, width: 115, height: 160, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "la-06-h1v5-09",
    name: "LA 09 - H1V5",
    albumType: "LA",
    thumbnail: "/thumbnails/LA/AR_2.50/la-06-h1_v5_09.png",
    size: [1274, 476],
    style: {},
    slots: [
            { id: "1", x: 91, y: 58, width: 140, height: 176, rotation: 0, imageRotation: 0 },
            { id: "2", x: 91, y: 241, width: 140, height: 175, rotation: 0, imageRotation: 0 },
            { id: "3", x: 239, y: 58, width: 532, height: 358, rotation: 0, imageRotation: 0 },
            { id: "4", x: 927, y: 58, width: 255, height: 358, rotation: 0, imageRotation: 0 },
            { id: "5", x: 779, y: 58, width: 140, height: 176, rotation: 0, imageRotation: 0 },
            { id: "6", x: 779, y: 241, width: 140, height: 175, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "la-06-h1v5-10",
    name: "LA 10 - H1V5",
    albumType: "LA",
    thumbnail: "/thumbnails/LA/AR_2.50/la-06-h1_v5_10.png",
    size: [1274, 476],
    style: {},
    slots: [
            { id: "1", x: 0, y: 182, width: 176, height: 255, rotation: 0, imageRotation: 0 },
            { id: "2", x: 184, y: 182, width: 176, height: 255, rotation: 0, imageRotation: 0 },
            { id: "3", x: 368, y: 182, width: 358, height: 255, rotation: 0, imageRotation: 0 },
            { id: "4", x: 733, y: 182, width: 176, height: 255, rotation: 0, imageRotation: 0 },
            { id: "5", x: 917, y: 182, width: 175, height: 255, rotation: 0, imageRotation: 0 },
            { id: "6", x: 1100, y: 182, width: 175, height: 255, rotation: 0, imageRotation: 0 }
    ],
}
];